import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=7642048a&"
import script from "./Configure.vue?vue&type=script&lang=js&"
export * from "./Configure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports